import { memo } from "react";
import { Modal, Box, Button } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
// Styling for the modal content
const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 368,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 2,
  borderRadius: '6px',
  outline: 'none'
};


interface InfoModalProps {
  open: boolean;
  handleClose: () => void;
  handleOk?: () => void;
  title?: string;
  description?: string;
  closeText?: string;
  submitText?: string;
  singleBtn?: boolean;
  // New: optional width override; callers that omit it keep the default 368
  width?: number | string;
}

const InfoModal: React.FC<InfoModalProps> = ({
  open,
  handleClose,
  handleOk,
  title = "Default Title",
  description = "Default description",
  closeText,
  submitText,
  singleBtn,
  width
}) => {
  return (
    <div>
      <Modal
        open={open}
        // only call handleClose for explicit intent (buttons / close icon)
        onClose={(event, reason) => {
          // reason can be 'backdropClick' or 'escapeKeyDown' - ignore these
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
          handleClose && handleClose();
        }}
        // disable Escape key default behavior for extra safety
        disableEscapeKeyDown={true}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        className="modal"
      >
        {/* Old: <Box sx={modalStyle} className="modal"> */}
        {/* New: honour the optional width prop, falling back to modalStyle's 368 */}
        <Box sx={{ ...modalStyle, width: width ?? modalStyle.width }} className="modal">
          <div className="modal-header flex justify-content-between align-items-center">
            {title &&
              <h3 className="modal-title">
                {title}
              </h3>
            }
            {/* Old: <button className="close" onClick={handleClose}><CloseIcon /></button> */}
            {/* New: marginLeft auto keeps the × on the right even when there is no title.
                With a title present, space-between already puts it there, so nothing changes. */}
            <button className="close" style={{ marginLeft: 'auto' }} onClick={handleClose}><CloseIcon /></button>
          </div>
          <div className="modal-body">
            <p className="modal-description">
              {description}
            </p>
          </div>
          <div className="modal-footer flex justify-content-center align-items-center">
            {closeText && <Button onClick={handleClose} className={singleBtn ? "primary-btn" : "border-btn"}>{closeText}</Button>}
            {submitText && <Button className="primary-btn" onClick={handleOk}>{submitText}</Button>}
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default memo(InfoModal);
